/**
 * In-memory cache for card detail + price data so swipe / arrow navigation
 * between cards feels instant.
 *
 * Capped at 200 entries per kind (FIFO) to avoid unbounded growth in a long
 * browsing session.
 *
 * Cache TTL: 5 minutes — long enough that swiping back and forth is instant,
 * short enough that newly-synced data eventually flows through.
 */
const TTL_MS = 5 * 60 * 1000;
const MAX_ENTRIES = 200;

function makeStore() {
  const map = new Map();
  return {
    get(key) {
      const hit = map.get(key);
      if (!hit) return null;
      if (Date.now() - hit.t > TTL_MS) {
        map.delete(key);
        return null;
      }
      return hit.v;
    },
    set(key, value) {
      if (map.size >= MAX_ENTRIES) {
        // FIFO eviction (Map preserves insertion order).
        const first = map.keys().next().value;
        if (first !== undefined) map.delete(first);
      }
      map.set(key, { t: Date.now(), v: value });
    },
    invalidate(key) {
      map.delete(key);
    },
  };
}

export const cardCache = makeStore();
export const priceCache = makeStore();
